import { render, staticRenderFns } from "./SelectIcon.vue?vue&type=template&id=57db8f3d"
import script from "./SelectIcon.vue?vue&type=script&lang=js"
export * from "./SelectIcon.vue?vue&type=script&lang=js"
import style0 from "./SelectIcon.vue?vue&type=style&index=0&id=57db8f3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports